import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.688 24h2.035a1.407 1.407 0 0 1 1.397 1.242l.01.164v12.188c0 .72-.544 1.315-1.243 1.396l-.164.01h-2.045c-.34 0-.659-.09-.935-.25l-.04-.023a1.891 1.891 0 0 1-.098-.064l.138.087a1.877 1.877 0 0 1-.896-1.22l-.004-.018a1.81 1.81 0 0 1-.03-.182 52.703 52.703 0 0 1-.312-5.373h.003l-.004-.424c.001-1.955.11-3.909.324-5.863a1.875 1.875 0 0 1 1.675-1.66l.189-.01h2.035-2.035Zm6.718 0h2.035c.449 0 .864.158 1.188.424l.031.026a1.873 1.873 0 0 1 .644 1.213l.001.007.09.908.026.265a49.647 49.647 0 0 1 .08 1.009c.085 1.23.127 2.456.128 3.68a52.762 52.762 0 0 1-.314 5.798 1.875 1.875 0 0 1-1.674 1.66l-.19.01h-2.045a1.406 1.406 0 0 1-1.396-1.242l-.01-.164V25.406c0-.72.543-1.315 1.242-1.396l.164-.01h2.035-2.035ZM24 9c7.474 0 13.67 5.464 14.812 12.616a4.82 4.82 0 0 0-1.49-.536C35.988 14.952 30.53 10.364 24 10.364c-7.532 0-13.636 6.104-13.636 13.636 0 7.136 5.48 12.99 12.46 13.586l.008.071c.05.464.166.907.335 1.32C15.27 38.546 9 32.007 9 24c0-8.285 6.715-15 15-15Zm1.84 28.498.003.014-.003-.014ZM24 15.904a8.1 8.1 0 0 1 7.692 5.562 4.355 4.355 0 0 0-1.618-.451L29.723 21h-2.035a4.875 4.875 0 0 0-4.846 4.343 56.987 56.987 0 0 0-.342 6.188l.001.427A8.098 8.098 0 0 1 24 15.903Z",
    fill: "currentColor"
  }));
};

var SvgRecordingPause = styled(SvgComponent).withConfig({
  displayName: "RecordingPause__SvgRecordingPause",
  componentId: "sc-1pohmv0-0"
})(["", " ", ""], size, color);
export default SvgRecordingPause;